import React, { useState } from 'react';
import { DASHBOARD_PAGE_PATHS } from '../../../routes/dashboardRoutes';

export const REQUEST_DELAY_OPTIONS = [
  { value: 0, label: 'No delay (fastest)' },
  { value: 100, label: '100 ms between requests' },
  { value: 250, label: '250 ms between requests' },
  { value: 500, label: '500 ms between requests' },
  { value: 1000, label: '1 second between requests' },
  { value: 2000, label: '2 seconds between requests' },
];

export function delayOptionsFor(current) {
  if (REQUEST_DELAY_OPTIONS.some((o) => o.value === current)) return REQUEST_DELAY_OPTIONS;
  return [...REQUEST_DELAY_OPTIONS, { value: current, label: `${current} ms between requests` }];
}

export function IpList({ title, ips, emptyText }) {
  const [copied, setCopied] = useState(false);
  const copyAll = async () => {
    try {
      await navigator.clipboard.writeText(ips.join('\n'));
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      setCopied(false);
    }
  };
  return (
    <div className="scan-network-iplist">
      <div className="scan-network-iplist-head">
        <span className="scan-network-iplist-title">{title}</span>
        {ips.length > 0 && (
          <button type="button" className="scan-network-copy" onClick={copyAll}>
            {copied ? 'Copied' : 'Copy all'}
          </button>
        )}
      </div>
      {ips.length > 0 ? (
        <ul className="scan-network-ips" aria-label={title}>
          {ips.map((ip) => (
            <li key={ip}><code>{ip}</code></li>
          ))}
        </ul>
      ) : (
        <p className="deployment-section-desc">{emptyText}</p>
      )}
    </div>
  );
}

/** How to get a locked product: buy the add-on, or ask the account manager. */
export function UpgradeHint({ product }) {
  const upgrade = product?.upgrade;
  if (!upgrade) return null;
  if (upgrade.action === 'buy') {
    return (
      <a className="scan-network-upgrade" href={DASHBOARD_PAGE_PATHS.subscription}>
        {upgrade.label}
        {upgrade.price ? ` · ${upgrade.price}` : ''}
      </a>
    );
  }
  return <span className="scan-network-upgrade-text">{upgrade.label}</span>;
}
